import React, { Component } from 'react'
import _ from 'lodash'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableFooter from '@material-ui/core/TableFooter'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { withStyles } from '@material-ui/core/styles'
import { saveAs } from 'file-saver'


const styles = theme => ({
  root : {
      marginTop : 6,
      color: '#676767',
  },
  select : {
      border: '1px solid #C7C7C7',
      padding : 8,
      paddingLeft: 5,
      paddingBottom: 9,
      color: '#676767',
      backgroundColor : '#fff',
  },
  disabled : {
      color : '#9E9E9E',
      backgroundColor : '#FCFCFC'
  },
  textField : {
      marginTop: 0,
  },
  input : {
      border: '1px solid #C7C7C7',
      paddingLeft: 5,
      color: '#676767',
      marginTop: 6,
      backgroundColor : '#fff',
  },
  label : {
      color : '#3CA7AC',
      fontSize : 18,
      fontWeight: 600,
      textTransform: 'capitalize',
  },
  item : {
      display: 'flex',
      alignItems: 'center',
  },
  icon : {
      backgroundSize: 'cover',
      width: 20,
      height: 20,
      display: 'inline-block',
      marginRight: "10px",
  },
  iconAprobado : { backgroundImage: 'url("/images/parametro_aprobado_small.png")' },
  iconEnUso : { backgroundImage: 'url("/images/parametro_en_uso_small.png")' },
  iconRechazado : { backgroundImage: 'url("/images/parametro_rechazado_small.png")' },
})

class ProyectoCompanyTable extends Component {
    
    saveFile = () => {
        try {
            saveAs(
            "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            "example.pdf"
            )
        }catch (error) {
            console.log("Error", error);
        } 
    }
    
    renderCompanies() {
        const { proyectos, } = this.props

        return _.map(proyectos, proyecto => { 
          const { id, nombre, datos_a_informar, datos_informados, datos_no_informados, datos_certificados, completitud, calidad } = proyecto   
          console.log("New column", Object.keys(proyecto))
        
            return(
                <TableRow  key={id}>
                <TableCell padding={"none"}></TableCell>
                <TableCell>{id}</TableCell>
                <TableCell>{nombre}</TableCell>
                <TableCell>{datos_a_informar}</TableCell>
                <TableCell>{datos_informados}</TableCell>
                <TableCell>{datos_no_informados}</TableCell>
                <TableCell>{datos_certificados}</TableCell>
                <TableCell>{completitud}%</TableCell>
                <TableCell>{calidad}%</TableCell>
                </TableRow>
            );
        });
    }

  render() {

    const { id } = this.props

    // let urlParticularExcel = process.env.API_URL + "/api/v1/reportes/download_reporte_proyecto/?proyecto_id=" + id

    return (
      <>
      <div>Empresas Involucradas en el Proyecto</div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding={"none"}></TableCell>
            <TableCell>ID</TableCell>
            <TableCell>Nombre</TableCell>
            <TableCell>Datos a Informar</TableCell>
            <TableCell>Datos Informados</TableCell>
            <TableCell>Datos no Informados</TableCell>
            <TableCell>Datos Certificados</TableCell>
            <TableCell>Completitud</TableCell>
            <TableCell>Calidad</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.renderCompanies()}
        </TableBody>
        <TableFooter>
      <TableRow>
        {/* <TableCell colSpan={6}>
                    <Pagination
                    page={this.props.page}
                    perPage={this.props.perPage}
                    isLoading={this.props.loading}
                    total={this.props.total}
                    setPage={this.props.onPageChange}
                    setPerPage={this.props.onPerPageChange}
                    labelRowsPerPage={"Proyectos por página:"}
                    labelDisplayedRows={({ from, to, count }) => `Mostrando resultados ${from} a ${to} de ${count}`}
                    />
        </TableCell> */}
        {/* <TableCell colSpan={2}>
            {this.props.value != '' && <a style={{ backgroundColor: '#78b7b4', color: 'white', fontSize: '14px', padding: '6px' }} href={urlParticularExcel} download target_="_blank" rel="noopener noreferrer">Descargar Instalaciones</a>}

            {this.props.value == '' && <a style={{ backgroundColor: '#78b7b4', color: 'white', fontSize: '14px', padding: '6px'}} href="http://activos-tx-qa.appspot.com/api/v1/reportes/download_reporte_proyecto" download target_="_blank" rel="noopener noreferrer">Descargar Excel</a>}
        </TableCell> */}
      </TableRow>
    </TableFooter>
      </Table></>
    )
  }
}

export default withStyles(styles)(ProyectoCompanyTable)
